import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LabelService } from 'src/app/shared/services/label.service';


@Component({
  selector: 'app-study-saved',
  templateUrl: './study-saved.component.html',
  styleUrls: ['./study-saved.component.scss'],
  standalone: false
})
export class StudySavedComponent {
  @Output() close = new EventEmitter()
  i18n = this.labelService.labels;
  @Input() from!: string;
  constructor(private readonly labelService: LabelService){}

  studySaved() {
    this.close.emit()
  }
}
